import { Navigate } from 'react-router-dom';
import { usePlatformModules } from '@/hooks/use-modules';
import {
  getAccessibleModules,
  getBoardLandingRoute,
  usePermissions,
} from '@/hooks/use-permissions';

/**
 * Redirects authenticated users to their default home surface.
 * A user whose only accessible module is H3Pay lands on /payroll;
 * otherwise Crew-Tech lands on My Dashboard (personal briefing) and
 * everyone else lands on the org-wide H3ightboard.
 */
export function RoleRedirect() {
  const { boardPersona, getModuleRole } = usePermissions();
  const { enabledModules, isLoading } = usePlatformModules();

  if (isLoading) return null;

  return (
    <Navigate
      to={getBoardLandingRoute(
        boardPersona,
        getAccessibleModules(enabledModules, getModuleRole),
      )}
      replace
    />
  );
}
